<template>
  <v-form @submit.prevent class="form">
    <input
      class="field"
      :value="value"
      type="text"
      @keyup.enter="send"
      :disabled="disabled"
      @input="onInput"
      placeholder="Type your message here"
    />
    <v-btn v-if="hasValue" @click="send" large icon><v-icon :style="{ color: btnBgColor }">{{ mdiSend }}</v-icon></v-btn>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
import { TextType } from 'components-system';
import { mdiSend } from '@mdi/js';

export default {
  name: 'Input',
  data() {
    return {
      value: null,
      mdiSend
    };
  },
  computed: {
    ...mapGetters({
      persistenceMenu: 'theme/persistenceMenu',
    }),
    hasValue() {
      return !!this.value;
    },
    disabled() {
      return this.persistenceMenu?.disableinput;
    },
    btnBgColor() {
      return this.$store.getters['theme/btnBgColor'];
    },
  },
  methods: {
    onInput(e) {
      this.value = e.target.value;
      this.$emit('input', e.target.value);
    },
    send() {
      if (this.value) {
        this.$store.dispatch('chatFlow/send', new TextType(this.value));
        this.value = null;
        this.$emit('input', null);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.field {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: none;
  outline: 0;
}
</style>
